"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
const cmd = require("@/assets/appImg/command.png");
const MODIFIER_KEYS = [
  "ControlLeft",
  "ControlRight",
  "AltLeft",
  "AltRight",
  "ShiftLeft",
  "ShiftRight",
  "MetaLeft",
  "MetaRight"
];
const MODIFIER_KEYS_VALUE = ["Ctrl", "Alt", "Shift", "Cmd"];
const FUNCTION_KEYS = [
  "Digit0",
  "Digit1",
  "Digit2",
  "Digit3",
  "Digit4",
  "Digit5",
  "Digit6",
  "Digit7",
  "Digit8",
  "Digit9",
  "KeyA",
  "KeyB",
  "KeyC",
  "KeyD",
  "KeyE",
  "KeyF",
  "KeyG",
  "KeyH",
  "KeyI",
  "KeyJ",
  "KeyK",
  "KeyL",
  "KeyM",
  "KeyN",
  "KeyO",
  "KeyP",
  "KeyQ",
  "KeyR",
  "KeyS",
  "KeyT",
  "KeyU",
  "KeyV",
  "KeyW",
  "KeyX",
  "KeyY",
  "KeyZ",
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "F10",
  "F11",
  "F12",
  "End",
  "Home",
  "Insert",
  "Tab",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "PageUp",
  "PageDown"
];
const KEY_DISPLAY_MAP = {
  ControlLeft: "Ctrl",
  ControlRight: "Ctrl",
  AltLeft: "Alt",
  AltRight: "Alt",
  ShiftLeft: "Shift",
  ShiftRight: "Shift",
  MetaLeft: "Cmd",
  MetaRight: "Cmd",
  Digit0: "0",
  Digit1: "1",
  Digit2: "2",
  Digit3: "3",
  Digit4: "4",
  Digit5: "5",
  Digit6: "6",
  Digit7: "7",
  Digit8: "8",
  Digit9: "9",
  KeyA: "A",
  KeyB: "B",
  KeyC: "C",
  KeyD: "D",
  KeyE: "E",
  KeyF: "F",
  KeyG: "G",
  KeyH: "H",
  KeyI: "I",
  KeyJ: "J",
  KeyK: "K",
  KeyL: "L",
  KeyM: "M",
  KeyN: "N",
  KeyO: "O",
  KeyP: "P",
  KeyQ: "Q",
  KeyR: "R",
  KeyS: "S",
  KeyT: "T",
  KeyU: "U",
  KeyV: "V",
  KeyW: "W",
  KeyX: "X",
  KeyY: "Y",
  KeyZ: "Z",
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  F6: "F6",
  F7: "F7",
  F8: "F8",
  F9: "F9",
  F10: "F10",
  F11: "F11",
  F12: "F12",
  End: "End",
  Home: "Home",
  Insert: "Insert",
  Tab: "Tab",
  ArrowLeft: "\u2190",
  ArrowRight: "\u2192",
  ArrowUp: "\u2191",
  ArrowDown: "\u2193",
  PageUp: "PageUp",
  PageDown: "PageDown"
};
const KEY_CODE_DISPLAY_MAP = {
  SHIFT: "Shift",
  ALT: "Alt",
  ArrowLeft: "\u2190",
  ArrowRight: "\u2192",
  ArrowUp: "\u2191",
  ArrowDown: "\u2193",
  Escape: "Esc",
  PageUp: "PageUp",
  PageDown: "PageDown",
  KeyA: "A",
  KeyB: "B",
  KeyC: "C",
  KeyD: "D",
  KeyE: "E",
  KeyF: "F",
  KeyG: "G",
  KeyH: "H",
  KeyI: "I",
  KeyJ: "J",
  KeyK: "K",
  KeyL: "L",
  KeyM: "M",
  KeyN: "N",
  KeyO: "O",
  KeyP: "P",
  KeyQ: "Q",
  KeyR: "R",
  KeyS: "S",
  KeyT: "T",
  KeyU: "U",
  KeyV: "V",
  KeyW: "W",
  KeyX: "X",
  KeyY: "Y",
  KeyZ: "Z",
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  F6: "F6",
  F7: "F7",
  F8: "F8",
  F9: "F9",
  F10: "F10",
  F11: "F11",
  F12: "F12",
  Digit0: "0",
  Digit1: "1",
  Digit2: "2",
  Digit3: "3",
  Digit4: "4",
  Digit5: "5",
  Digit6: "6",
  Digit7: "7",
  Digit8: "8",
  Digit9: "9",
  End: "End",
  Home: "Home",
  Insert: "Insert",
  Tab: "Tab",
  Backspace: "Backspace",
  Delete: "Delete",
  Enter: "Enter",
  Space: "Space"
};
let QuickSettingConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.cmd = cmd;
    // 第一个快捷键
    this.firstHotKey = [];
    this.isRecordingFirst = false;
    // 第二个快捷键
    this.secondHotKey = [];
    this.isRecordingSecond = false;
    // 开启或关闭快捷键功能
    this.hotKeyFlag = false;
    // 当前记录的按键
    this.currentKeys = /* @__PURE__ */ new Set();
    // 当前系统 windows darwin
    this.currentSystem = "windows";
    // 延迟录制完成的定时器
    this.recordingTimer = null;
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        yield this.NewInitHotKey();
        yield this.getSystem();
      } catch (error) {
      }
    });
  }
  getSystem() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.local/update/version`);
        this.currentSystem = response.data.os.name.toLowerCase();
      } catch (error) {
        this.currentSystem = "windows";
      }
    });
  }
  // 重新进行INIT
  NewInitHotKey() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.local/storages/preference/hoyKeyFlag`
        );
        this.hotKeyFlag = response.data.value.flag;
        if (this.hotKeyFlag) {
          yield this.getHotKey();
        }
      } catch (error) {
        let flag = false;
        this.hotKeyFlag = flag;
        yield API.put(`api://base.local/storages/preference/hotKeyFlag`, {
          flag
        });
      }
    });
  }
  changeHotKeyFlag(flag) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/hotKeyFlag`, {
          flag: this.hotKeyFlag
        });
        if (this.hotKeyFlag) {
          yield this.getHotKey();
        } else {
          yield API.delete(`api://base.local/v2/hotkey/hide_window`);
          yield API.delete(`api://base.local/v2/hotkey/show_window`);
        }
      } catch (error) {
        console.log(error);
        this.hotKeyFlag = !this.hotKeyFlag;
      }
    });
  }
  getHotKey() {
    return __async(this, null, function* () {
      try {
        this.firstHotKey = [];
        this.secondHotKey = [];
        let response = yield API.get(`api://base.local/v2/hotkey`);
        if (response.data.length > 0) {
          for (let item of response.data) {
            if (item.action === "hide_window") {
              for (let key of item.modifiers) {
                if (key === "CMD_OR_CTRL") {
                  this.firstHotKey.push("Ctrl");
                } else if (key === "CMD" || key === "META") {
                  this.firstHotKey.push("Cmd");
                } else if (key === "CTRL" || key === "CONTROL") {
                  this.firstHotKey.push("Ctrl");
                } else {
                  this.firstHotKey.push(KEY_CODE_DISPLAY_MAP[key]);
                }
              }
              this.firstHotKey.push(KEY_CODE_DISPLAY_MAP[item.key]);
            }
            if (item.action === "show_window") {
              for (let key of item.modifiers) {
                if (key === "CMD_OR_CTRL") {
                  this.secondHotKey.push("Ctrl");
                } else if (key === "CMD" || key === "META") {
                  this.secondHotKey.push("Cmd");
                } else if (key === "CTRL" || key === "CONTROL") {
                  this.secondHotKey.push("Ctrl");
                } else {
                  this.secondHotKey.push(KEY_CODE_DISPLAY_MAP[key]);
                }
              }
              this.secondHotKey.push(KEY_CODE_DISPLAY_MAP[item.key]);
            }
          }
        } else {
          yield this.initHotKey();
        }
      } catch (error) {
        yield this.initHotKey();
      }
    });
  }
  initHotKey() {
    return __async(this, null, function* () {
      try {
        const data = {
          modifiers: ["CMD_OR_CTRL", "SHIFT"],
          key: "Digit0",
          action: "hide_window"
        };
        this.firstHotKey = ["Ctrl", "Shift", "0"];
        yield API.put(`api://base.local/v2/hotkey`, data);
        const data2 = {
          modifiers: ["CMD_OR_CTRL", "SHIFT"],
          key: "Digit9",
          action: "show_window"
        };
        this.secondHotKey = ["Ctrl", "Shift", "9"];
        yield API.put(`api://base.local/v2/hotkey`, data2);
      } catch (error) {
        this.firstHotKey = ["Ctrl", "Shift", "0"];
        this.secondHotKey = ["Ctrl", "Shift", "9"];
      }
    });
  }
  editHideHotKey() {
    return __async(this, null, function* () {
      if (this.isRecordingFirst)
        return;
      this.isRecordingFirst = true;
      this.firstHotKey = [];
      this.currentKeys.clear();
      window.addEventListener("keydown", this.checkFirstHotKey);
      window.addEventListener("keyup", this.handleKeyUp);
    });
  }
  editShowHotKey() {
    return __async(this, null, function* () {
      if (this.isRecordingSecond)
        return;
      this.isRecordingSecond = true;
      this.secondHotKey = [];
      this.currentKeys.clear();
      window.addEventListener("keydown", this.checkSecondHotKey);
      window.addEventListener("keyup", this.handleKeyUp);
    });
  }
  checkFirstHotKey(event) {
    event.preventDefault();
    this.handleKeyDown(event, "first");
  }
  checkSecondHotKey(event) {
    event.preventDefault();
    this.handleKeyDown(event, "second");
  }
  handleKeyDown(event, type) {
    const keyCode = event.code;
    console.log(keyCode);
    if (!MODIFIER_KEYS.includes(keyCode) && !FUNCTION_KEYS.includes(keyCode)) {
      return;
    }
    this.currentKeys.add(keyCode);
    const currentKeyArray = Array.from(this.currentKeys);
    const hasCtrlOrMeta = currentKeyArray.some(
      (key) => key === "ControlLeft" || key === "ControlRight" || key === "MetaLeft" || key === "MetaRight"
    );
    const hasShift = currentKeyArray.some(
      (key) => key === "ShiftLeft" || key === "ShiftRight"
    );
    const hasAlt = currentKeyArray.some(
      (key) => key === "AltLeft" || key === "AltRight"
    );
    const functionKeyCount = currentKeyArray.filter(
      (key) => FUNCTION_KEYS.includes(key)
    ).length;
    if (this.recordingTimer) {
      clearTimeout(this.recordingTimer);
      this.recordingTimer = null;
    }
    if (FUNCTION_KEYS.includes(keyCode)) {
      if (hasCtrlOrMeta && functionKeyCount === 1 && !hasAlt) {
        const displayKeys = Array.from(this.currentKeys).map((key) => KEY_DISPLAY_MAP[key]).filter((key) => key);
        if (type === "first") {
          this.firstHotKey = displayKeys;
        } else {
          this.secondHotKey = displayKeys;
        }
        this.recordingTimer = setTimeout(() => {
          if (type === "first") {
            this.stopRecordingFirst();
          } else {
            this.stopRecordingSecond();
          }
        }, 300);
      } else {
        this.recordingTimer = setTimeout(() => {
          if (type === "first") {
            this.firstHotKey = [];
            this.stopRecordingFirst();
          } else {
            this.secondHotKey = [];
            this.stopRecordingSecond();
          }
        }, 300);
      }
    } else if (MODIFIER_KEYS.includes(keyCode)) {
      if (hasAlt && !hasCtrlOrMeta) {
        return;
      }
      const displayKeys = Array.from(this.currentKeys).filter((key) => MODIFIER_KEYS.includes(key)).map((key) => KEY_DISPLAY_MAP[key]).filter((key) => key);
      if (type === "first") {
        this.firstHotKey = displayKeys;
      } else {
        this.secondHotKey = displayKeys;
      }
    }
  }
  handleKeyUp(event) {
    this.currentKeys.delete(event.code);
  }
  stopRecordingFirst() {
    return __async(this, null, function* () {
      this.isRecordingFirst = false;
      window.removeEventListener("keydown", this.checkFirstHotKey);
      window.removeEventListener("keyup", this.handleKeyUp);
      if (this.recordingTimer) {
        clearTimeout(this.recordingTimer);
        this.recordingTimer = null;
      }
      const hasCtrlOrCmd = this.firstHotKey.some(
        (key) => ["Ctrl", "Cmd"].includes(key)
      );
      const hasAlt = this.firstHotKey.some((key) => key === "Alt");
      const functionKeys = this.firstHotKey.filter(
        (key) => !["Ctrl", "Alt", "Shift", "Cmd"].includes(key)
      );
      const hasFunctionKey = functionKeys.length === 1;
      if (!hasCtrlOrCmd || !hasFunctionKey || hasAlt || this.firstHotKey.length < 2) {
        this.firstHotKey = [];
        this.$message.warning(
          this.$t("quick-setting-config.must_include_ctrl_or_cmd")
        );
      } else {
        yield this.saveHideHotKey();
        console.log("111");
        this.$message.success(
          this.$t("quick-setting-config.hotkey_saved")
        );
      }
      this.currentKeys.clear();
      yield this.getHotKey();
    });
  }
  saveHideHotKey() {
    return __async(this, null, function* () {
      try {
        let modifiers = [];
        let item = "";
        for (let key of this.firstHotKey) {
          if (MODIFIER_KEYS_VALUE.includes(key)) {
            if (key === "Ctrl") {
              if (this.currentSystem === "windows") {
                modifiers.push("CTRL");
              } else {
                modifiers.push("CONTROL");
              }
            } else if (key === "Cmd") {
              if (this.currentSystem === "windows") {
                modifiers.push("META");
              } else {
                modifiers.push("CMD");
              }
            } else {
              modifiers.push(key.toUpperCase());
            }
          } else {
            let keyCode = Object.keys(KEY_DISPLAY_MAP).find(
              (k) => KEY_DISPLAY_MAP[k] === key
            );
            if (keyCode) {
              item = keyCode;
            }
          }
        }
        let data = {
          modifiers,
          key: item,
          action: "hide_window"
        };
        yield API.put(`api://base.local/v2/hotkey`, data);
      } catch (error) {
      }
    });
  }
  saveShowHotKey() {
    return __async(this, null, function* () {
      try {
        let modifiers = [];
        let item = "";
        for (let key of this.secondHotKey) {
          if (MODIFIER_KEYS_VALUE.includes(key)) {
            if (key === "Ctrl") {
              if (this.currentSystem === "windows") {
                modifiers.push("CTRL");
              } else {
                modifiers.push("CONTROL");
              }
            } else if (key === "Cmd") {
              if (this.currentSystem === "windows") {
                modifiers.push("META");
              } else {
                modifiers.push("CMD");
              }
            } else {
              modifiers.push(key.toUpperCase());
            }
          } else {
            let keyCode = Object.keys(KEY_DISPLAY_MAP).find(
              (k) => KEY_DISPLAY_MAP[k] === key
            );
            if (keyCode) {
              item = keyCode;
            }
          }
        }
        let data = {
          modifiers,
          key: item,
          action: "show_window"
        };
        yield API.put(`api://base.local/v2/hotkey`, data);
      } catch (error) {
      }
    });
  }
  stopRecordingSecond() {
    return __async(this, null, function* () {
      this.isRecordingSecond = false;
      window.removeEventListener("keydown", this.checkSecondHotKey);
      window.removeEventListener("keyup", this.handleKeyUp);
      if (this.recordingTimer) {
        clearTimeout(this.recordingTimer);
        this.recordingTimer = null;
      }
      const hasCtrlOrCmd = this.secondHotKey.some(
        (key) => ["Ctrl", "Cmd"].includes(key)
      );
      const hasAlt = this.secondHotKey.some((key) => key === "Alt");
      const functionKeys = this.secondHotKey.filter(
        (key) => !["Ctrl", "Alt", "Shift", "Cmd"].includes(key)
      );
      const hasFunctionKey = functionKeys.length === 1;
      if (!hasCtrlOrCmd || !hasFunctionKey || hasAlt || this.secondHotKey.length < 2) {
        this.secondHotKey = [];
        this.$message.warning(
          this.$t("quick-setting-config.must_include_ctrl_or_cmd")
        );
      } else {
        yield this.saveShowHotKey();
        console.log("222");
        this.$message.success(
          this.$t("quick-setting-config.hotkey_saved")
        );
      }
      this.currentKeys.clear();
      yield this.getHotKey();
    });
  }
  // 组件销毁时清理事件监听器
  beforeDestroy() {
    window.removeEventListener("keydown", this.checkFirstHotKey);
    window.removeEventListener("keydown", this.checkSecondHotKey);
    window.removeEventListener("keyup", this.handleKeyUp);
    if (this.recordingTimer) {
      clearTimeout(this.recordingTimer);
      this.recordingTimer = null;
    }
  }
};
__decorateClass([
  Debounce(500)
], QuickSettingConfig.prototype, "changeHotKeyFlag", 1);
__decorateClass([
  Debounce(600)
], QuickSettingConfig.prototype, "editHideHotKey", 1);
__decorateClass([
  Debounce(600)
], QuickSettingConfig.prototype, "editShowHotKey", 1);
QuickSettingConfig = __decorateClass([
  Component
], QuickSettingConfig);
export {
  QuickSettingConfig as default
};
